var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevenLogomark = function SvgElevenLogomark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "elevenLogomark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#elevenLogomark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.067 68.934 92 48.001 72 27.868ZM53.867 9.733 48 4 4 48l17.2 17.2ZM63.734 19.6l-5.867-5.867-22 66L48 92l4.533-4.4Z"
  }))));
};
export default SvgElevenLogomark;